// extracted by mini-css-extract-plugin
module.exports = {"body":"Form_body__1UVBM","colEmail":"Form_colEmail__1AKjG","modal":"Form_modal__1nIcY"};